<template>
  <div class="coagency search_box">
    <div class="coagency-content">
      <div class="srarch_t">
        <div class="serch_l">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="书城" name="书城">
              <span slot="label">{{
                activeName === "书城" ? `书城 ( ${total.tstotal} )` : `书城`
              }}</span>
            </el-tab-pane>
            <el-tab-pane label="专题" name="专题">
              <span slot="label">{{
                activeName === "专题" ? `专题 ( ${total.zttotal} )` : `专题`
              }}</span>
            </el-tab-pane>
            <el-tab-pane label="作者" name="作者">
              <span slot="label">{{
                activeName === "作者" ? `作者 ( ${total.zztotal} )` : `作者`
              }}</span>
            </el-tab-pane>
            <el-tab-pane label="机构" name="机构">
              <span slot="label">{{
                activeName === "机构" ? `机构 ( ${total.jgtotal} )` : `机构`
              }}</span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="custom-search">
          <input
            type="text"
            v-model.trim="searchName"
            @keyup.enter="handleQuery"
            class="custom-input"
            placeholder="请输入"
          />
          <el-button
            class="custom-button"
            @click="handleQuery"
            round
            type="primary"
            icon="el-icon-search"
            >搜索
          </el-button>
        </div>
      </div>
      <div class="search_show">
        <div class="search_li" v-show="activeName === '书城'">
          <book
            ref="book"
            :search-name="searchName"
            :eachColor="eachColor"
            @settotal="settotal"
          ></book>
        </div>
        <div class="search_li" v-show="activeName === '专题'">
          <special
            ref="special"
            :search-name="searchName"
            :eachColor="eachColor"
            @settotal="settotal"
          ></special>
        </div>
        <div class="search_li" v-show="activeName === '作者'">
          <authorLibrary
            ref="authorLibrary"
            :search-name="searchName"
            :eachColor="eachColor"
            @settotal="settotal"
          >
          </authorLibrary>
        </div>
        <div class="search_li" v-show="activeName === '机构'">
          <coagency
            ref="coagency"
            :search-name="searchName"
            :eachColor="eachColor"
            @settotal="settotal"
          ></coagency>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeName: "书城",
      searchName: "",
      total: {
        tstotal: 0,
        zttotal: 0,
        zztotal: 0,
        jgtotal: 0,
      },
    };
  },
  // computed: {
  //   ...mapGetters(["searchText"]),
  // },
  // watch: {
  //   searchText() {
  //     if (this.$route.path === "/search/index") {
  //       this.searchName = this.$route.query.text;
  //       this.handleQuery();
  //     }
  //   },
  // },

  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.searchName = this.$route.query.text;
        this.handleQuery();
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
    });
    console.log("this.$route.query.text", this.$route.query.text);
    this.searchName = this.$route.query.text;

    setTimeout(() => {
      this.handleQuery();
      loading.close();
    }, 200);
    this.handleQuery();
  },
  components: {
    book: () => import("./components/book.vue"),
    special: () => import("./components/special.vue"),
    authorLibrary: () => import("./components/authorLibrary.vue"),
    coagency: () => import("./components/coagency.vue"),
  },
  methods: {
    handleClick(name) {},
    //搜索结果关键字改变颜色
    eachColor(content, searchVal, searchVal2) {
      if (content) {
        if (searchVal) {
          let nt = '<span style="color:#FF5353;">' + searchVal + "</span>";
          content = content.replace(searchVal, nt);
        }
        if (searchVal2) {
          let nt2 = '<span style="color:#FF5353;">' + searchVal2 + "</span>";
          content = content.replace(searchVal2, nt2);
        }
      }
      return content;
    },
    handleQuery() {
      // this.$store.state.read.searchText = this.$parent.$children[0].searchText;
      console.log("this.searchName", this.searchName);
      this.$refs.book.getList(this.searchName);
      this.$refs.special.getList(this.searchName);
      this.$refs.authorLibrary.getList(this.searchName);
      this.$refs.coagency.getList(this.searchName);
    },
    settotal(type, total) {
      this.total[type] = total;
    },
  },
};
</script>
<style scoped lang="scss">
.coagency {
  height: auto;
  padding-bottom: 40px;

  // background: #FBFBFB;
  .coagency-content {
    width: 1400px;
    overflow: hidden;
    margin: 0 auto;
    background: #fffefd;
    box-sizing: border-box;
    padding: 16px 28px 40px 24px;

    .coagency-list {
      box-sizing: border-box;
      margin: 28px 0 40px 12px;
      display: grid;
      grid-row-gap: 30px;
      column-gap: 40px;
      grid-template-columns: repeat(auto-fit, 302px);

      .demo-box {
        width: 302px;
        height: 222px;
        background: #ffffff;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;

        .demo-img-box {
          width: 300px;
          height: 130px;
          background: #ffffff;
          cursor: pointer;

          img {
            box-sizing: border-box;
            padding: 8px 5px;
            max-width: 300px;
            max-height: 130px;
          }
        }

        .demo-body-box {
          box-sizing: border-box;
          padding: 18px 16px 20px;

          .coagency-title {
            cursor: pointer;
            width: 260px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-bottom: 20px;
          }

          .coagency-title:hover {
            color: #1690ff;
            text-decoration: underline;
          }

          .demo-resource-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 14px;

            .coagency-info {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #666666;

              span {
                color: #0081ce;
              }
            }
          }
        }
      }
    }

    .el-pagination {
      text-align: right;
    }
  }
}

.el-tabs {
  ::v-deep .el-tabs__nav-wrap {
    .el-tabs__item {
      span {
        font-size: 16px;
      }
    }
  }
}

.serch_l {
  height: 63px;
  margin-top: -16px;
}

.serch_l ::v-deep .el-tabs__nav-scroll {
  height: 63px;
}

.serch_l ::v-deep .el-tabs__item {
  line-height: 63px;
  height: 63px;
}

.serch_l ::v-deep .el-tabs__item span {
  padding: 0 10px;
}

.search_show {
  width: 100%;
  float: left;
}

.srarch_t {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
}
</style>
